import { ReportDTO } from '../../../shared/DTO/ReportDTO';

export class Reports {
    constructor(private reports: Report[]) { }

    static fromDTO(reportsDTO: ReportDTO[]) {
        const reports: Report[] = [];
        reportsDTO.forEach(r => reports.push(Report.fromDTO(r)));
        return new Reports(reports);
    }

    getReports(): Report[] {
        return this.reports;
    }

    getMostRecentReport(): Report {
        return this.reports.sort((r1, r2) => {
            if (r1.getSentAt() > r2.getSentAt()) {
                return 1;
            }
            if (r1.getSentAt() < r2.getSentAt()) {
                return -1;
            }
            return 0;
        }).pop();
    }
}

export class Report {
    constructor(private id: number, private campaign: string, private sentAt: Date) { }

    static fromDTO(reportDTO: ReportDTO): Report {
        return new Report(reportDTO.id, reportDTO.campaign, reportDTO.send_at);
    }

    getId(): number {
        return this.id;
    }

    getCampaign(): string {
        return this.campaign;
    }

    getSentAt(): Date {
        return this.sentAt;
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/energy/energy-reports/energy-reports.model.ts